import { memo } from "react"
import Mastercard from "../../assets/images/Mastercardimage.svg";
import { Link } from "react-router-dom";
import "../../assets/styles/components/Footer/cartfooter.css"

const CartFooter=() => {
     return (
        <div className="container-fluid" style={{ background:"rgb(221 219 219 / 49%)"}}>
             <div className="cart001">
                <img src={Mastercard} alt="master card"/>
                <Link to="" style={{ color:"rgb(51 50 50)", textDecoration:"none", fontWidth:"500"}}>Need Help? Contact Us </Link>
            </div>
       </div>
     )
}
export default memo(CartFooter);
